exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".selected[data-v-41b59a1b] {\n  background-color: #242F94;\n  color: #ffffff;\n  border-color: #ffffff;\n}\n.btn.disabled[data-v-41b59a1b], .btn[data-v-41b59a1b]:disabled {\n  opacity: 0.4;\n}\n.project-recipe-card-component[data-v-41b59a1b] {\n  margin: 0 1rem;\n}", ""]);

// exports
